
export default class Fee {
    public feeAmount: number;
    public feeDescription: string;
    public feeType: FeeType;
}

export enum FeeType {
    ApplicationFee = 1,
    ExaminationFeePrimaryInitial = 2,
    ExaminationFeeSubspecialtyInitial = 3,
    ExaminationFeeMoc = 4,
    ExaminationTransferInitial = 5,
    ExaminationTransferMoc = 6,
    LateFeeInitial = 7,
    LateFeeMoc = 8,
    ReturnedPaymentFee = 9,
    ExaminationFeeMocWithTwoModules = 10,
    ExaminationFeeMocWithThreeOrMoreModules = 11,
    CCAnnualFee = 12,
    ReseatingFee = 13,
    Refund = 14,
    DuplicateCertificate = 15,
}